// Added the className prop here to allow external styling
const Avatar = ({ profile, className }) => {
  const customImage = profile?.avatar_url || profile?.bubble_image_url;
  
  // Create default sizing and shape classes, but allow className from props to override or complement them
  const defaultClasses = "w-12 h-12 rounded-full object-cover";
  const finalClass = className || defaultClasses;

  if (customImage) {
    return (
      <img 
        src={customImage} 
        alt={profile?.name || profile?.display_name || 'User'} 
        className={finalClass} 
        referrerPolicy="no-referrer"
      />
    );
  }

  // Deterministic logic to select a default avatar based on the user ID
  const baseId = profile?.user_id || profile?.id || 0;
  const imageIndex = baseId % 5; // Assuming there are 5 default avatar images named default-0.png to default-4.png
  const defaultAvatarPath = `/images/avatars/default-${imageIndex}.png`;

  return (
    <img 
      src={defaultAvatarPath} 
      alt="Default avatar" 
      className={finalClass}
    />
  );
};

export default Avatar;